import { useState, useEffect } from 'react';

export interface Geolocation {
  latitude: number;
  longitude: number;
  accuracy: number;
}

export const useGeolocation = () => {
  const [location, setLocation] = useState<Geolocation | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const geoSuccess = (pos: GeolocationPosition) => {
      setLocation({
        latitude: pos.coords.latitude,
        longitude: pos.coords.longitude,
        accuracy: pos.coords.accuracy,
      });
      setIsLoading(false);
    };

    const geoError = (err: GeolocationPositionError) => {
      setError(err.message);
      setIsLoading(false);
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(geoSuccess, geoError, {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      });
    } else {
      setError('Geolocation is not supported');
      setIsLoading(false);
    }
  }, []);

  return {
    location,
    error,
    isLoading,
  };
};
